import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class MultipleEmailsValidator {
    static validate(control: AbstractControl): ValidationErrors | null {

        const value = control.value;


        if (!value || !Array.isArray(value) || value.length === 0) {
            return null;
        }
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        const invalids = value.filter(
            (email: string) => typeof email !== 'string' || !emailRegex.test(email)
        );

        if (invalids.length > 0) {
            return {
                emailArray: {
                    invalidEmails: invalids
                }
            };
        }

        return null;
    }
}
